import { rankItem } from "@tanstack/match-sorter-utils";
import {
  // ColumnFiltersState,
  FilterFn,
  flexRender,
  getCoreRowModel,
  // getFacetedMinMaxValues,
  // getFacetedRowModel,
  // getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useEffect, useMemo, useState } from "react";
// import {
//   FaCheckCircle,
//   FaClock,
//   FaComments,
//   FaPlayCircle,
//   FaRegFileAlt,
//   FaSearch,
//   // FaMapMarkerAlt,
//   FaSignInAlt,
//   FaUserCircle,
// } from "react-icons/fa";
import DateFilterForm from "./DateFilterForm";
import { FaSearch } from "react-icons/fa";
import { filterDataByDate, services } from "./Constants";
import useCommonStore from "../store/CommonStore";
import { usePagination } from "../features/hooks/usePagination";
import AgentFilterForm from "./AgentFilterForm";
import FeedbackFilterForm from "./FeedbackFilterForm";
import UserDropdown from "./UserDropdownFilter";
import EmailFilterDropdown from "./EmailFilterDropdown";
import ServiceStatusCards from "../features/maintenance/ServiceStatusCards";
// import StatsButton from "./StatsButton";

type ReactTanstackTableProps = {
  data: any;
  columns: any;
  pagination?: boolean;
  noDataMessage?: string | undefined;
  hideSearchInput?: boolean;
  tableTitle?: string;
  additionalButton?: string | null;
  btnUrl?: string;
  customLayout?: boolean;
  disableRowHeight?: boolean;
  externalPagination?: {
    pageIndex: number;
    setPageIndex: (index: number) => void;
    pageSize: number;
    setPageSize: (size: number) => void;
    total: number;
    totalPages: number;
  };
  isLoading?: boolean;
  isAgentDropdown?: string | null;
  isFeedbackDropdown?: boolean;
  isChat?: boolean;
  individualUser?: boolean;
  emailInvites?: boolean;
  isAddBtn?: string | null;
  onAddBtnClick?: () => void;
};

type SearchInputProps = {
  value?: string | undefined;
  onChange: (value: string) => void;
  debounce?: number;
  className?: string;
  placeholder?: string;
};

// const fuzzyFilter: FilterFn<any> = (
//   row: { getValue: (columnId: string) => any },
//   columnId: string,
//   value: any,
//   addMeta: (meta: { itemRank: { passed: boolean } }) => void
// ) => {
//   const itemRank = rankItem(row.getValue(columnId), value);

//   addMeta({
//     itemRank,
//   });

//   return itemRank.passed;
// };

const fuzzyFilter: FilterFn<any> = (
  row: { getValue: (columnId: string) => any },
  columnId: string,
  value: any,
  addMeta: (meta: { itemRank: { passed: boolean } }) => void
) => {
  const cellValue = row.getValue(columnId);

  if (!cellValue || typeof cellValue !== "string") return false;

  const itemRank = rankItem(cellValue.toLowerCase(), value.toLowerCase());

  addMeta({
    itemRank,
  });

  return itemRank.passed;
};

function ReactTanstackTableUi({
  data,
  columns,
  pagination,
  noDataMessage,
  hideSearchInput,
  tableTitle,
  additionalButton,
  btnUrl,
  customLayout,
  disableRowHeight,
  externalPagination,
  isLoading,
  isAgentDropdown,
  isFeedbackDropdown,
  isChat,
  individualUser,
  emailInvites,
  isAddBtn,
  onAddBtnClick,
}: ReactTanstackTableProps) {
  const [globalFilter, setGlobalFilter] = useState("");
  // const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const {
    selectedValue,
    setSelectedValue,
    customRange,
    setCustomRange,
    selectedAgent,
    setSelectedAgent,
    selectedFeedback,
    setSelectedFeedback,
    mailStatusFilter,
    setMailStatusFilter,
  } = useCommonStore();

  const commonPagination = usePagination();
  const { setPageIndex } = commonPagination;

  const [selectedTopic, setSelectedTopic] = useState<string | null>(null);

  const {
    filteredData,
    newlyRegisteredUsers,
    totalRegisteredUsers,
    isNewUsers,
  } = useMemo(() => {
    return filterDataByDate(data, selectedValue, selectedTopic);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, selectedValue, selectedTopic]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const displayedData = useMemo(() => {
    if (tableTitle === "Users") {
      return isNewUsers ? newlyRegisteredUsers : totalRegisteredUsers;
    }
    return filteredData;
  }, [
    tableTitle,
    isNewUsers,
    newlyRegisteredUsers,
    totalRegisteredUsers,
    filteredData,
  ]);

  // const table = useReactTable({
  //   data: displayedData,
  //   columns,
  //   filterFns: {
  //     fuzzy: fuzzyFilter,
  //   },
  //   state: {
  //     columnFilters,
  //     globalFilter,
  //   },
  //   onColumnFiltersChange: setColumnFilters,
  //   onGlobalFilterChange: setGlobalFilter,
  //   globalFilterFn: fuzzyFilter,

  //   getCoreRowModel: getCoreRowModel(),
  //   getFilteredRowModel: getFilteredRowModel(),
  //   getSortedRowModel: getSortedRowModel(),
  //   getPaginationRowModel: getPaginationRowModel(),
  //   getFacetedRowModel: getFacetedRowModel(),
  //   getFacetedUniqueValues: getFacetedUniqueValues(),
  //   getFacetedMinMaxValues: getFacetedMinMaxValues(),
  // });

  // const table = useReactTable({
  //   data: displayedData,
  //   columns,
  //   manualPagination: true, // 🔑 This disables internal row slicing
  //   pageCount: externalPagination?.totalPages, // optional for future use
  //   state: {
  //     columnFilters,
  //     globalFilter,
  //     pagination: externalPagination
  //       ? {
  //           pageIndex: externalPagination.pageIndex,
  //           pageSize: externalPagination.pageSize,
  //         }
  //       : undefined,
  //   },
  //   onPaginationChange: externalPagination
  //     ? (updater) => {
  //         if (typeof updater === "function") {
  //           const newState = updater({
  //             pageIndex: externalPagination.pageIndex,
  //             pageSize: externalPagination.pageSize,
  //           });
  //           externalPagination.setPageIndex(newState.pageIndex);
  //           externalPagination.setPageSize(newState.pageSize);
  //         }
  //       }
  //     : undefined,
  //   getCoreRowModel: getCoreRowModel(),
  //   getFilteredRowModel: getFilteredRowModel(),
  //   getSortedRowModel: getSortedRowModel(),
  //   globalFilterFn: fuzzyFilter,
  //   filterFns: {
  //     fuzzy: fuzzyFilter,
  //   },
  // });

  const table = useReactTable({
    data: data,
    columns,
    manualPagination: true,
    pageCount: externalPagination?.totalPages,
    state: {
      // columnFilters,
      globalFilter,
      pagination: externalPagination
        ? {
            pageIndex: externalPagination.pageIndex,
            pageSize: externalPagination.pageSize,
          }
        : undefined,
    },
    onPaginationChange: externalPagination
      ? (updater) => {
          if (typeof updater === "function") {
            const newState = updater({
              pageIndex: externalPagination.pageIndex,
              pageSize: externalPagination.pageSize,
            });

            externalPagination.setPageIndex(newState.pageIndex);
            externalPagination.setPageSize(newState.pageSize);
          }
        }
      : undefined,
    getCoreRowModel: getCoreRowModel(),
    ...(externalPagination
      ? {}
      : {
          getFilteredRowModel: getFilteredRowModel(),
          getSortedRowModel: getSortedRowModel(),
          getPaginationRowModel: getPaginationRowModel(),
        }),
    globalFilterFn: fuzzyFilter,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
  });

  const handleTopicClick = (topic: string | null) => {
    if (topic === selectedTopic) {
      setSelectedTopic("");
      return;
    } else {
      setSelectedTopic(topic);
    }
  };

  return (
    <div
      className={`flex flex-col overflow-x-auto ${
        tableTitle ? "gap-3" : ""
      }  w-full bg-white  px-4`}
    >
      <div
        className={` flex md:flex-row flex-col md:items-center  justify-between mx-3 md:mx-5 ${
          tableTitle ? "mt-10 gap-3" : ""
        }`}
      >
        <h3
          className={`w-full font-semibold ${
            individualUser ? "text-xl" : "text-3xl"
          } page-heading text-gray-800`}
        >
          {tableTitle || null}
        </h3>
      </div>

      {tableTitle === "Maintenance" &&
      isAddBtn === "Add Maintenance" &&
      services?.length ? (
        <div className="px-4">
          <ServiceStatusCards services={services} />
        </div>
      ) : null}

      <div className="flex justify-between items-center px-4 gap-4 w-full">
        {!hideSearchInput && !individualUser && (
          // <div className="flex items-center border border-gray-300 rounded-md h-9 px-4 w-full text-sm focus:outline-none">
          <div
            className={`flex items-center border border-gray-300 rounded-md h-9 px-4 text-sm focus:outline-none ${
              isAgentDropdown || isFeedbackDropdown ? "md:w-[45%]" : "w-[75%]"
            }`}
          >
            <SearchInput
              value={globalFilter || ""}
              onChange={(value: string) => setGlobalFilter(String(value))}
              className="flex-1"
              placeholder={`Search ${tableTitle}`}
            />
            <FaSearch className="w-4 h-4 text-gray-400" />
          </div>
        )}

        {isAgentDropdown === "true" && (
          // <div className=" flex items-center justify-end w-1/3">
          <div className="flex items-center justify-end md:w-[25%] w-full">
            <AgentFilterForm
              selectedAgent={selectedAgent}
              setSelectedAgent={setSelectedAgent}
            />
          </div>
        )}

        {isChat && (
          // <div className=" flex items-center justify-end w-1/3">
          <div className="flex items-center justify-end md:w-[25%] w-full">
            <UserDropdown />
          </div>
        )}

        {emailInvites && (
          // <div className=" flex items-center justify-end w-1/3">
          <div className="flex items-center justify-end md:w-[25%] w-full">
            <EmailFilterDropdown
              mailStatusFilter={mailStatusFilter}
              setMailStatusFilter={setMailStatusFilter}
            />
          </div>
        )}

        {isFeedbackDropdown && (
          // <div className=" flex items-center justify-end w-1/3">
          <div className="flex items-center justify-end md:w-[25%] w-full">
            <FeedbackFilterForm
              selectedFeedback={selectedFeedback}
              setSelectedFeedback={setSelectedFeedback}
            />
          </div>
        )}

        {tableTitle === "User Feedback" && (
          <>
            <div className="flex items-center justify-end md:w-[25%] w-full"></div>
            <div className="flex items-center justify-end md:w-[30%] w-full">
              <FeedbackFilterForm
                selectedFeedback={selectedFeedback}
                setSelectedFeedback={setSelectedFeedback}
              />
            </div>
          </>
        )}

        {!individualUser && (
          <div className="flex items-center justify-end md:w-[26%] w-full">
            <DateFilterForm
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              customRange={customRange}
              setCustomRange={setCustomRange}
              setPageIndex={setPageIndex}
            />
          </div>
        )}

        {isAddBtn && (
          <button
            type="button"
            onClick={onAddBtnClick}
            className="bg-black font-medium whitespace-nowrap border-2 border-black text-white py-1.5 px-3 text-sm rounded-md"
          >
            {isAddBtn}
          </button>
        )}
      </div>

      {tableTitle === "Feedback List" && (
        <div className="flex gap-3 px-4 my-2">
          <div
            onClick={() => handleTopicClick("Cumstom Comment")}
            className={`${
              selectedTopic === "Cumstom Comment"
                ? "border-enterprise bg-enterprise_bg hover:bg-enterprise_bg"
                : "text-primary hover:bg-hoverbg border-[#E7ECF1]"
            } flex gap-1 p-2 px-2 md:px-2 md:py-2 h-9 md:h-10 cursor-pointer text-decoration-none text-xs md:text-sm font-normal border rounded-md transition-colors duration-200 w-fit`}
          >
            {"Cumstom Comment"}
          </div>
          <div
            onClick={() => handleTopicClick("Like")}
            className={`${
              selectedTopic === "Like"
                ? "border-enterprise bg-enterprise_bg hover:bg-enterprise_bg"
                : "text-primary hover:bg-hoverbg border-[#E7ECF1]"
            } flex gap-1 p-2 px-2 md:px-2 md:py-2 h-9 md:h-10 cursor-pointer text-decoration-none text-xs md:text-sm font-normal border rounded-md transition-colors duration-200 w-fit`}
          >
            {"Like"}
          </div>
          <div
            onClick={() => handleTopicClick("Dislike")}
            className={`${
              selectedTopic === "Dislike"
                ? "border-enterprise bg-enterprise_bg hover:bg-enterprise_bg"
                : "text-primary hover:bg-hoverbg border-[#E7ECF1]"
            } flex gap-1 p-2 px-2 md:px-2 md:py-2 h-9 md:h-10 cursor-pointer text-decoration-none text-xs md:text-sm font-normal border rounded-md transition-colors duration-200 w-fit`}
          >
            {"Dislike"}
          </div>
        </div>
      )}

      <div className={`border rounded-md mx-4`}>
        <table className={`mx-auto w-full`}>
          <thead className=" h-[40px] text-sm border-b border-[#929292] bg-[#F0F4F8] w-full">
            {table.getHeaderGroups().map((headerGroup: any) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header: any, index: number) => {
                  const obj = columns[index];
                  const columnClass = obj.columnClass || "";
                  return (
                    <th
                      key={header.id}
                      className={` whitespace-pre-wrap  max-w-xs md:pl-5 pl-3  text-left font-bold text-[#323232] ${columnClass} `}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header?.column?.columnDef?.header,
                            header.getContext()
                          )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          {isLoading ? (
            <tbody>
              {Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} className="animate-pulse bg-white h-16">
                  {columns.map((_: any, colIndex: any) => (
                    <td key={colIndex} className="px-4 py-2">
                      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ) : data?.length > 0 ? (
            <tbody>
              {table?.getRowModel().rows.map((row: any, index: number) => {
                return (
                  <tr
                    key={row.id}
                    className={` ${
                      index % 2 !== 0 ? "bg-bg-white" : "bg-white"
                    } ${disableRowHeight ? "h-[41px]" : "h-16"}  `}
                  >
                    {row.getVisibleCells().map((cell: any, index: number) => {
                      const obj = columns[index];
                      const columnClass = obj.columnClass || "";

                      return (
                        <td
                          key={cell.id}
                          className={` whitespace-pre-wrap  md:px-5 p-1 text-base text-[#323232] border-b border-gray-300 ${columnClass} `}
                        >
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan={columns.length}>
                  <div className="text-center text-gray-500 py-10 text-base">
                    No data found for the selected period.
                  </div>
                </td>
              </tr>
            </tbody>
          )}
        </table>
        {/* {data.length <= 0 ? "No Data Found" : null} */}
        {pagination && data?.length > 0 ? (
          <Pagination table={table} externalPagination={externalPagination} />
        ) : null}
      </div>
    </div>
  );
}

export default ReactTanstackTableUi;

function SearchInput({
  value: initialValue,
  onChange,
  debounce = 500,
  className,

  ...props
}: SearchInputProps) {
  const [value, setValue] = useState(initialValue || "");
  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  return (
    <input
      {...props}
      value={value}
      onChange={handleInputChange}
      className={className}
    />
  );
}

// function Pagination({ table }: any) {
//   const pageCount = table.getPageCount();
//   const pageIndex = table.getState().pagination.pageIndex;

//   const maxPagesToShow = 5;
//   const halfMaxPages = Math.floor(maxPagesToShow / 2);

//   const pageRangeStart = Math.max(0, pageIndex - halfMaxPages);
//   const pageRangeEnd = Math.min(pageCount - 1, pageIndex + halfMaxPages);

//   const pageNumbersToShow = [
//     ...Array(pageRangeEnd - pageRangeStart + 1)?.keys(),
//   ].map((i) => i + pageRangeStart);

//   const handlePageClick = (pageIndex: number) => {
//     table.setPageIndex(pageIndex);
//   };

//   return (
//     <div className="md:m-5 m-3 flex md:flex-row  justify-between flex-col md:items-center  gap-3">
//       <div className="mx-1 hidden items-center text-sm text-gray-700 md:flex">
//         Showing
//         <span className="mx-1 font-medium">
//           {table.getState().pagination.pageIndex + 1}
//         </span>
//         to
//         <span className="mx-1 font-medium">{table.getPageCount()}</span>
//         of
//         <span className="mx-1 font-medium">
//           {table.getPrePaginationRowModel().rows.length}
//         </span>
//         Results
//       </div>

//       <nav
//         className=" md:gap-2 gap-1  flex items-center justify-end"
//         aria-label="Pagination"
//       >
//         <button
//           onClick={() => table.setPageIndex(0)}
//           disabled={!table.getCanPreviousPage()}
//           className="relative hidden md:inline-flex items-center rounded-md h-9 w-9 justify-center text-[#656C78] focus:z-20 focus:outline-offset-0"
//         >
//           <span className="sr-only">Previous</span>
//           <span>{"<<"}</span>
//         </button>
//         <button
//           onClick={() => table.previousPage()}
//           disabled={!table.getCanPreviousPage()}
//           className="relative inline-flex items-center justify-center rounded-md h-9 w-9 text-[#656C78] focus:z-20 focus:outline-offset-0"
//         >
//           <span className="sr-only">Previous</span>
//           <span>{"<"}</span>
//         </button>

//         {pageNumbersToShow.map((number) => {
//           const active = number === pageIndex;
//           return (
//             <button
//               key={number}
//               onClick={() => handlePageClick(number)}
//               disabled={active}
//               className={`relative inline-flex items-center h-9 w-9 justify-center ${
//                 active
//                   ? "z-10  bg-[#E6F7FF] text-[#005AC2]"
//                   : " border-none  text-gray-900"
//               }  text-sm ring-0 font-semibold rounded-full  `}
//             >
//               {number + 1}
//             </button>
//           );
//         })}

//         <button
//           onClick={() => table.nextPage()}
//           disabled={!table.getCanNextPage()}
//           className="relative inline-flex items-center rounded-md h-9 w-9 justify-center text-[#656C78] focus:z-20 focus:outline-offset-0"
//         >
//           <span className="sr-only">Next</span>
//           <span>{">"}</span>
//         </button>
//         <button
//           onClick={() => table.setPageIndex(table.getPageCount() - 1)}
//           disabled={!table.getCanNextPage()}
//           className="relative hidden md:inline-flex items-center rounded-md h-9 w-9 justify-center text-[#656C78] focus:z-20 focus:outline-offset-0"
//         >
//           <span className="sr-only">Next</span>
//           <span>{">>"}</span>
//         </button>
//         <span className="text-[#25282E] text-sm font-normal leading-5">
//           Items per page
//         </span>
//         <select
//           className="rounded-md border h-[40px] w-[80px] px-2 text-sm text-gray-500 focus:outline-none"
//           value={table.getState().pagination.pageSize}
//           onChange={(e) => {
//             table.setPageSize(Number(e.target.value));
//           }}
//         >
//           {[10, 20, 30, 40, 50, 100].map((pageSize) => (
//             <option key={pageSize} value={pageSize}>
//               {pageSize}
//             </option>
//           ))}
//         </select>
//       </nav>
//     </div>
//   );
// }

function Pagination({ table }: any) {
  const pageIndex = table.getState().pagination.pageIndex;
  const pageSize = table.getState().pagination.pageSize;

  // const totalRows = table.getFilteredRowModel().rows.length;
  const pageCount = table.getPageCount();

  const maxPagesToShow = 5;
  const halfMaxPages = Math.floor(maxPagesToShow / 2);

  let pageRangeStart = Math.max(0, pageIndex - halfMaxPages);
  let pageRangeEnd = pageRangeStart + maxPagesToShow - 1;

  if (pageRangeEnd >= pageCount) {
    pageRangeEnd = pageCount - 1;
    pageRangeStart = Math.max(0, pageRangeEnd - maxPagesToShow + 1);
  }

  const pageNumbersToShow = Array.from(
    { length: pageRangeEnd - pageRangeStart + 1 },
    (_, i) => i + pageRangeStart
  );

  // const startEntry = pageIndex * pageSize + 1;
  // const endEntry = Math.min(startEntry + pageSize - 1, totalRows);

  return (
    <div className="md:m-5 m-3 flex md:flex-row justify-between flex-col md:items-center gap-3">
      {/* Showing X–Y of Z */}
      <div className="mx-1 text-sm text-gray-700">
        Showing
        <span className="mx-1 font-medium">
          {table.getState().pagination.pageIndex + 1}
        </span>
        to
        <span className="mx-1 font-medium">{table.getPageCount()}</span>
        of
        <span className="mx-1 font-medium">
          {table.getPrePaginationRowModel().rows.length}
        </span>
        Results
      </div>

      <nav
        className="md:gap-2 gap-1 flex items-center justify-end"
        aria-label="Pagination"
      >
        <button
          onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
          className="disabled:opacity-20 disabled:cursor-not-allowed"
        >
          {"<<"}
        </button>
        <button
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          className="disabled:opacity-20 disabled:cursor-not-allowed"
        >
          {"<"}
        </button>

        {pageNumbersToShow.map((number) => {
          const isActive = number === pageIndex;
          return (
            <button
              key={number}
              onClick={() => table.setPageIndex(number)}
              disabled={isActive}
              className={`h-9 w-9 rounded-full text-sm font-semibold ${
                isActive ? "bg-[#E6F7FF] text-[#005AC2]" : "text-gray-900"
              }`}
            >
              {number + 1}
            </button>
          );
        })}

        <button
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          className="disabled:opacity-20 disabled:cursor-not-allowed"
        >
          {">"}
        </button>
        <button
          onClick={() => table.setPageIndex(pageCount - 1)}
          disabled={!table.getCanNextPage()}
          className="disabled:opacity-20 disabled:cursor-not-allowed"
        >
          {">>"}
        </button>

        <span className="text-[#25282E] text-sm font-normal leading-5 ml-3">
          Items per page
        </span>
        <select
          className="rounded-md border h-[40px] w-[80px] px-2 text-sm text-gray-500"
          value={pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </nav>
    </div>
  );
}
